import React from 'react';

import { FiltersOptionsByKey } from '@ihme/common/types';
import { Clearfix, Form } from '@ihme/common/web/components';
import { withStorage, WithStorageProps } from '@ihme/common/packages/storage';
import _ from '@ihme/common/locale';
import styled from '@ihme/common/theme/styled';

import api from '../../../api';
import levelUpAllCausesInHierarchy from '../../../utility/level-up-all-causes-in-hierarchy';

import ChartDropdown from '../../../components/ChartDropdown';
import AgeGroupsDropdown from '../../../components/AgeGroupsDropdown';
import MetricsDropdown from '../../../components/MetricsDropdown';
import HierarchicalDropdown from '../../../components/HierarchicalDropdown';

const ButtonGroup = styled.div(({ theme }) => ({
    marginBottom: 10,
    '> *': {
        width: 200,
        marginRight: 12,
        marginBottom: 10,
        [theme.breakpoint.xs]: {
            width: 252,
        },
    },
}));

const StyledHierarchicalDropdown = styled(HierarchicalDropdown)(({ theme }) => ({
    width: '100%',
    maxWidth: 414,
}));

type Props = WithStorageProps & {
    refinedGranularity: FiltersOptionsByKey;
    isAgeStandardizedSelected: boolean;
};

class MapChartFilters extends React.Component<Props> {
    loadCauseHierarchy = () =>
        this.props
            .cached(api.getExtendedCauses)()
            .then(levelUpAllCausesInHierarchy)
            .catch(console.log);

    render() {
        const { refinedGranularity } = this.props;

        return (
            <Form inline>
                <ButtonGroup>
                    <ChartDropdown
                        label={_('filter_measure_title').toUpperCase()}
                        localePrefix="measure_"
                        filterKey="measure_id"
                    />
                    <MetricsDropdown refinedOptions={refinedGranularity.metric_id} />
                    <AgeGroupsDropdown refinedOptions={refinedGranularity.age_group_id} />
                    <StyledHierarchicalDropdown
                        label={_('filter_cause_title').toUpperCase()}
                        loadHierarchy={this.loadCauseHierarchy}
                        localePrefix="cause_"
                        filterKey="cause_id"
                        isSearchable
                        rootLevel={1}
                        useLetterPrefix={false}
                        preprocessOptions={options => options.filter(
                            option => !option.label.includes('severity level')
                        )}
                    />
                </ButtonGroup>
                <Clearfix />
            </Form>
        );
    }
}

export default withStorage(MapChartFilters);
